import * as React from 'react';
import { AppKeys } from '@microsoft/portal-app/lib/environment/getUrlForApp';
import { css, mergeStyles, Theme, ThemeContext } from '@fluentui/react';
import { showSpeechSettingsFlag } from '../../Language/Language/LanguageConfig';
import { AccountCard } from '../AccountCard';
import { IAccountHomeProps, IAccountHomeState } from './AccountHome.types';
import { settingsManager } from '../../shared/settings';
import { ResponsiveConnectedPersonBadge } from '../PersonBadge/ResponsiveConnectedPersonBadge';
import { RETRIEVING_CREDENTIALS, VERIFIEDID_APP_NAME_LINKEDIN } from '../../shared/constants';
import { RetrievingCredentials } from '../Credential/RetrievingCredentials';
import { createUrl, isMobile } from '../../shared/utils';

const accountHomeStyles = require('./AccountHome.scoped.scss');
const isMySignInsEnabled = settingsManager.get('isMySignInsEnabled') || false;

export class AccountHome extends React.Component<IAccountHomeProps, IAccountHomeState> {
  public componentDidMount(): void {
    this.props.checkOfficeLicenses();
    showSpeechSettingsFlag();
  }
  public render(): React.ReactNode {
    const { t, tenantId, dispatchRouterAction } = this.props;
    const convergedSecurityInfoUrl = createUrl(AppKeys.signins, false, false, 'security-info', tenantId);

    const urlParams = new URLSearchParams(window.location.search);
    const appName = urlParams.get(RETRIEVING_CREDENTIALS);

    if (appName?.toLowerCase() === VERIFIEDID_APP_NAME_LINKEDIN.toLowerCase() && isMobile()) {
      return <RetrievingCredentials appName={appName} />;
    }

    return (
      <ThemeContext.Consumer>
        {(theme: Theme | undefined) => {
          return (
            <main
              className={mergeStyles(
                'ms-AccountHome',
                accountHomeStyles.page,
                theme && {
                  fontSize: theme.fonts.medium.fontSize,
                },
              )}
            >
              <div className={css('ms-AccountContainer', accountHomeStyles.pageContainer)}>
                <div className={css('ms-AccountContent', accountHomeStyles.pageContent)}>
                  <ResponsiveConnectedPersonBadge />
                  <div className={accountHomeStyles.cardGroupFirstCol}>
                    {isMySignInsEnabled && (
                      <AccountCard
                        cardKey="Security-info"
                        title={t('securityInfo')}
                        iconName={'EditContact'}
                        description={t('securityInfoTileSubtext')}
                        primaryLinkText={t('updateInfo')}
                        primaryLink={convergedSecurityInfoUrl}
                        isInternalLink={false}
                        dispatchRouterAction={dispatchRouterAction}
                      />
                    )}
                    <AccountCard
                      cardKey="Devices"
                      title={t('devices')}
                      iconName={'System'}
                      description={t('devicesTileSubtext')}
                      primaryLinkText={t('devicesTileAction')}
                      primaryLink={createUrl('/device-list', true, false)}
                      isInternalLink={true}
                      dispatchRouterAction={dispatchRouterAction}
                    />
                  </div>
                  <div className={accountHomeStyles.cardGroupSecondCol}>
                    <AccountCard
                      cardKey="Password"
                      title={t('changePassword')}
                      iconName={'Permissions'}
                      description={t('passwordTileSubtext')}
                      primaryLinkText={t('passwordTileAction')}
                      primaryLink={settingsManager.get('changePasswordFwdLink')}
                      isInternalLink={false}
                      dispatchRouterAction={dispatchRouterAction}
                    />
                    <AccountCard
                      cardKey="Organizations"
                      title={t('Organizations')}
                      iconName={'Work'}
                      description={t('organizationsTileSubtext')}
                      primaryLinkText={t('organizationsTileAction')}
                      primaryLink={createUrl('/organizations', true, false)}
                      isInternalLink={true}
                      dispatchRouterAction={dispatchRouterAction}
                    />
                  </div>
                  <div className={accountHomeStyles.cardGroupThirdCol}>
                    <AccountCard
                      cardKey="Settings And Privacy"
                      title={t('settingsAndPrivacyCardTitle')}
                      iconName={'Settings'}
                      description={t('settingsAndPrivacyCardDescription')}
                      primaryLinkText={t('settingsAndPrivacyCardLinkText')}
                      primaryLink={createUrl('/settingsandprivacy', true, false)}
                      isInternalLink={true}
                      dispatchRouterAction={this.props.dispatchRouterAction}
                    />
                    {isMySignInsEnabled && (
                      <AccountCard
                        cardKey="My SignIns"
                        title={t('mySignIns')}
                        iconName={'Signin'}
                        description={t('mySignInsTileSubtext')}
                        primaryLinkText={t('mySignInsTileAction')}
                        primaryLink={createUrl(AppKeys.signins, false, false)}
                        isInternalLink={false}
                        dispatchRouterAction={dispatchRouterAction}
                      />
                    )}
                  </div>
                </div>
              </div>
            </main>
          );
        }}
      </ThemeContext.Consumer>
    );
  }
}
